import React from "react";
import "../../Styles/DashboardHome.css";
import { IMAGES } from "../../utils/images";
import { CONTINUE_LEARNING } from "../../utils/dashboardConstant";
import SimpleCharts from "./BarChart";
import GaugeValueRangeNoSnap from "./PieChart";

const DashboardHome = () => {
  return (
    <div className="dashboard-content">
      <div className="home-heading-container">
        <h1 className="heading-text-h1">Hello, Varun</h1>
        <p className="heading-text-p">Welcome to edutech Dashboard</p>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="overview-container">
        <div className="overview">
          <IMAGES.CERTIFICATES_ICON className="over-icon" />
          <div className="content-container">
            <h2>2</h2>
            <p>Total Certificates</p>
          </div>
        </div>
        <div className="overview">
          <IMAGES.TOTAL_COURSES className="over-icon" />
          <div className="content-container">
            <h2>2</h2>
            <p>Total Certificates</p>
          </div>
        </div>
        <div className="overview">
          <IMAGES.TOTAL_MATERIALS className="over-icon" />
          <div className="content-container">
            <h2>2</h2>
            <p>Total Certificates</p>
          </div>
        </div>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="continue-learning">
        <h2 className="continue-learn-head">Continue Learning</h2>
        <div className="video-cards-container">
          {CONTINUE_LEARNING.map((course) => {
            console.log(course.backgroundimage);
            return (
              <div className="video-container" key={course.id}>
                <div className="video-card">
                  <IMAGES.RECORDED_ICON className="play-icon" />
                  <img
                    src={course.backgroundimage}
                    className="background-image"
                  />
                </div>
                <p className="video-card-content">{course.title}</p>
              </div>
            );
          })}
        </div>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="continue-learning">
        <h2 className="continue-learn-head">Performance </h2>
        <div className="video-cards-container">
          <div className="Graph-container">
            <p>Weekly Attendance </p>
            <SimpleCharts className="chart" />
          </div>
          <div className="Graph-container-2">
            <p>Course </p>
            <GaugeValueRangeNoSnap className="pie-chart" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;
